import { DSSponsorInfo } from 'shared-definitions/types'
import { ApiSponsorInfoProps } from 'data-source/types.wp'

export function sponsorInfoMapper(input: ApiSponsorInfoProps): DSSponsorInfo {
  return {
    sponsored: input.sponsored ?? false,
    sponsor: input.sponsor
      ? `${input.sponsor_label ? input.sponsor_label + ' ' : ''}${input.sponsor}`
      : null,
  }
}
